<template>
  <div
    @click="
      $emit(
        'userSelected',
        this.recipientId,
        this.recipientDisplayname,
        this.recipientConnectedAccountStatus,
        recipientImageDataComputed,
        this.recipientDiffCurrency,
        this.recipientRyftConnAccId,
        this.recipientUseRyft,
        this.recipientEnforceUseRyft
      )
    "
    class="wrapper-todiv"
    style="cursor: pointer"
  >
    <div
      :class="
        this.recipientRecentlyTippedDate === undefined
          ? 'userinfoframe'
          : 'userinfoframelasttipped'
      "
      style="height: 9vh"
    >
      <table align="left" style="height: 85%" border="0" width="100%">
        <thead>
          <tr>
            <!-- ref font size 0 below, weird hack required see https://stackoverflow.com/questions/10500249/perfect-vertical-image-alignment -->
            <td
              align="left"
              width="20%"
              style="height: 8vh; font-size: 0; text-align: center"
            >
              <img
                border="0"
                :v-if="recipientImageData !== undefined"
                :src="recipientImageDataComputed"
                style="height: 7vh; border-radius: 50%"
              />
            </td>
            <!-- <td align=left width=20% ><img :v-if="recipientImageData!==undefined" :src="'data:image/png;base64,' + recipientImageData" width="50" height="50" ></td> -->
            <!-- '../assets/tulogoapp.png' -->
            <td>
              <!-- nested table -->
              <table border="0" width="100%">
                <thead>
                  <tr>
                    <td
                      class="username"
                      style="text-align: left; outline: 0em solid green"
                    >
                      {{ this.recipientDisplayname }}
                    </td>

                    <!-- Existing last-tipped (unchanged) -->
                    <td
                      v-if="this.recipientRecentlyTippedDate !== undefined"
                      class="lastTippedText"
                      style="
                        text-align: right;
                        padding-right: 0.5vh;
                        outline: 0em solid green;
                      "
                    >
                      Last tipped {{ this.recipientLastTippedAmount }} on
                      {{ this.recipientRecentlyTippedDate }}
                    </td>
                  </tr>
                </thead>
              </table>
            </td>
            <!-- HARI's checkbox square -->
            <td
              v-if="this.isHARIs === true && this.multiSelectEnabled === true"
              style="width: 44px; text-align: right; padding-right: 1.2vh"
            >
              <div
                :class="
                  this.isSelected
                    ? 'haris-recipient-check haris-recipient-check-on'
                    : 'haris-recipient-check'
                "
              ></div>
            </td>
          </tr>
        </thead>
      </table>
    </div>
    <p></p>
  </div>
</template>

<script>
export default {
  name: "Recipient",
  props: {
    recipientId: String,
    recipientDisplayname: String,
    recipientImageData: String,
    recipientImageFileType: String,
    recipientConnectedAccountStatus: Boolean,
    recipientDiffCurrency: Object,
    recipientRecentlyTippedDate: String,
    recipientLastTippedAmount: String,
    recipientRyftConnAccId: String,
    recipientUseRyft: Boolean,
    recipientEnforceUseRyft: Boolean,
    isHARIs: Boolean,
    multiSelectEnabled: Boolean,
    isSelected: Boolean,
  },
  watch: {
    recipientImageData: {
      handler(val) {
        if (val && typeof val === "string") {
          // console.log(`ImageData changed for ${this.recipientId}, now starts with: ${val.substring(0, 30)}`);
        } else {
          // console.log(`ImageData changed for ${this.recipientId}, but no image data present.`);
        }
      },
      immediate: true,
    },
  },
  computed: {
    recipientImageDataComputed() {
      // /console.log("Let's compute image");
      if (this.recipientImageData) {
        // // /console.log("YEA:: " + this.recipientImageData);
        return (
          "data:image/" +
          this.recipientImageFileType +
          ";base64," +
          this.recipientImageData
        );
      } else {
        // // /console.log("NAY");
        return require("@/assets/accountperson.png");
        // this was the syntax for plain old img src, but since it is now bound :src, the above is the syntax  "../assets/tulogoapp.png";
      }
    },
  },
  mounted() {
    // console.log("this.recipientDisplayname: " + this.recipientDisplayname);
    // console.log("RECIPIENT recipientDiffCurrency: " + JSON.stringify(this.recipientDiffCurrency, null, 2));
  },
};
</script>



<style scoped>
.lastTippedText {
  display: flex;
  font-size: 11px;
  color: #718096;
}

.haris-recipient-check {
  width: 20px;
  height: 20px;
  border-radius: 5px;
  background: #cfcfcf;
}

.haris-recipient-check-on {
  background: #95aeed;
  position: relative;
}
</style>